import React from 'react';
import { Row, Col } from 'reactstrap';
import { SortableContainer, SortableItem, Label } from './styled';

export default (function (_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === undefined ? 'Items' : _ref$label,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      onSortEnd = _ref.onSortEnd,
      _removeHandler = _ref.removeHandler,
      noResultsText = _ref.noResultsText;
  return items.length ? React.createElement(
    'div',
    null,
    React.createElement(
      Label,
      null,
      label
    ),
    React.createElement(
      Row,
      null,
      React.createElement(
        Col,
        { xs: '12' },
        React.createElement(
          SortableContainer,
          { onSortEnd: onSortEnd, useDragHandle: true },
          items.map(function (_ref2, idx) {
            var label = _ref2.label;
            return React.createElement(SortableItem, {
              key: 'item-' + label,
              index: idx,
              value: label,
              removeHandler: function removeHandler() {
                return _removeHandler(idx);
              } });
          })
        )
      )
    )
  ) : React.createElement(
    Label,
    null,
    noResultsText
  );
});